import { render, staticRenderFns } from "./EnvironmentProtection.vue?vue&type=template&id=771890c1&"
import script from "./EnvironmentProtection.vue?vue&type=script&lang=js&"
export * from "./EnvironmentProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports